
import { createBindDouyinAccount } from '@/zsm-api-new/dyCloud/commerce/coupon.js'
const state = {

}

const mutations = {

}

const actions = {

   /**
     * 创建达人账号活动
     * @param loginCode 讲师手机号 
     * @param talentAccount 达人账号 
     * @param nickname 达人姓名    
     */
    createBindDouyinAccount({ commit }, info) {
        info = {
            ...info,
            loginCode: JSON.parse(JSON.parse(this.state['zsm-user'].userInfo)).mobile
        }
        return new Promise((resolve, reject) => {
            createBindDouyinAccount(info).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
